
import { Quest, QuestCategory } from '../../../types';

export const JUNIOR_ENGINEER_QUESTS: Quest[] = [
  {
    id: 1600,
    category: QuestCategory.SkillBuilder,
    title: 'Know Your Tools',
    questlineId: 'junior-engineer',
    isQuestlineStart: true,
    description: 'Every great engineer knows their tools. Learn the basics of the most common tool: the screwdriver.',
    details: 'Ask an adult to show you a Phillips (cross) and a flathead (slot) screwdriver. Learn the phrase "righty-tighty, lefty-loosey". Practice turning a screw into a spare piece of wood and taking it out again.'
  },
  {
    id: 1601,
    category: QuestCategory.SkillBuilder,
    title: 'Measure Twice',
    questlineId: 'junior-engineer',
    prerequisiteQuestId: 1600,
    description: 'Accuracy is everything in engineering. Learn to use a tape measure correctly.',
    details: 'With a tape measure, carefully measure the width, height, and depth of five different objects around the house (like a book, a cereal box, or a table). Write down your measurements in a "Log Book" (your notebook).'
  },
  {
    id: 1602,
    category: QuestCategory.SkillBuilder,
    title: 'The Spirit of the Level',
    questlineId: 'junior-engineer',
    prerequisiteQuestId: 1601,
    description: 'Learn how engineers make sure things are perfectly flat.',
    details: 'Ask an adult to show you how a spirit level works. Use it to find three things in the house that are perfectly level, and one thing that is not. Understanding this tool is key to building things that don\'t fall over!'
  },
  {
    id: 1603,
    category: QuestCategory.TeamUp,
    title: 'The Apprentice',
    questlineId: 'junior-engineer',
    prerequisiteQuestId: 1602,
    description: 'An engineer learns by doing. Your mission is to help with a real DIY project.',
    details: 'Offer your skills to help an adult with a simple DIY job. You could help assemble a piece of flat-pack furniture, put up a picture, or build something in the garden. Your job is to be a useful assistant.'
  },
  {
    id: 1604,
    category: QuestCategory.SkillBuilder,
    title: 'The Tightening Tour',
    questlineId: 'junior-engineer',
    prerequisiteQuestId: 1603,
    description: 'Time for some preventative maintenance. Go on a mission to tighten up loose things around the house.',
    details: 'With supervision, take your screwdriver and go on a "tightening tour". Gently check screws on things like cabinet handles, door knobs, and chairs to see if any are loose. Tighten them up. You\'re making your home safer and more secure.'
  }
];
